<template>
  <v-container fluid>

    <h1>Disclaimer</h1>

    <p>Last updated: 2021-02-11</p>

    <p class="mt-6">
      wiseinfo.io is in no way connected to the team of WISE or Peter Girr.
    </p>
    <p>
      This is no financial advise. We are no financial adviser. Don't invest anything you can't afford to lose. Do your own due diligence
    </p>
    <p>
      wiseinfo.io provides referral links like <ReferrerLink>this one</ReferrerLink>. To support us you are very welcome to use those referral links which will give you +10% more shares and wiseinfo.io will get an equivalent amount in cm referrer shares.
    </p>


  </v-container>
</template>

<script>
  import ReferrerLink from "@/components/ReferrerLink.vue"

  export default {
    name: "Disclaimer",
    components: {
      ReferrerLink,
    },
  };
</script>

<style>
</style>
